import * as Sentry from "@sentry/react";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export function RouteErrorBoundary({ children }: { children: React.ReactNode }) {
  return (
    <Sentry.ErrorBoundary
      // eslint-disable-next-line @typescript-eslint/unbound-method -- Sentry types resetError as a method signature; it's a plain callback, no `this` binding involved.
      fallback={({ error, resetError }) => (
        <div className="p-4 md:p-8">
          <Card className="p-8 max-w-xl mx-auto text-center space-y-3">
            <AlertTriangle className="w-8 h-8 text-destructive mx-auto" />
            <p className="font-semibold">This page hit an error</p>
            <p className="text-sm text-muted-foreground">
              {error instanceof Error ? error.message : "Something went wrong rendering this view."}
            </p>
            <p className="text-xs text-muted-foreground">
              This has been reported automatically. Try again, or reload if it persists.
            </p>
            <div className="flex gap-2 justify-center pt-2">
              <Button variant="outline" onClick={() => resetError()}>Try again</Button>
              <Button onClick={() => window.location.reload()}>Reload page</Button>
            </div>
          </Card>
        </div>
      )}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
